// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @ commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

class InsuranceRequestWizardStep3LinkTooltip extends React.Component {
    constructor(props) {
        super(props);

        this.handleTooltipMouseOver = this.handleTooltipMouseOver.bind(this);
    }

    handleTooltipMouseOver(link) {
        this.tooltipHover = setTimeout(() => {
            this.props.onHandleTooltipMouseOver(link)
        }, 2000);
    }

    render() {
        const {
            link,
            content,
            isPostAppraisal,
            onHandleTooltipMouseOver,
            onHandleTooltipMouseOut
        } = this.props;

        const messageClassName = classNames('insurance-request-wizard-step-three__tooltip-message', {
            'insurance-request-wizard-step-three__tooltip-message-post-appraisal': isPostAppraisal
        });

        const tooltipTargetElement = (
            <a
                className="buttons-base-old buttons-base-old--additional-action-primary"
                onMouseOver={() => onHandleTooltipMouseOver(link)}
                onMouseOut={onHandleTooltipMouseOut}
            >
                <span className="insurance-request-wizard-step-three__link-hands">{link}</span>
            </a>
        );
        const tooltipContent = (
            <section className="insurance-request-wizard-step-three__hands-tooltip">
                <div className="insurance-request-wizard-step-three__tooltip-title">
                    <i className={content.className}></i>
                    <p className="insurance-request-wizard-step-three__tooltip-title-text">{content.title}</p>
                </div>
                <div className={messageClassName}>{content.message}</div>
            </section>
        );
        return (
            <OKTooltip
                content={tooltipContent}
                modifier="dark-bg"
                size="large"
                offset={[0, -15]}
                target={tooltipTargetElement}
                type="custom"
            />
        );
    }
}

InsuranceRequestWizardStep3LinkTooltip.propTypes = {
    link: PropTypes.string.isRequired,
    content: PropTypes.object.isRequired,
    onHandleTooltipMouseOver: PropTypes.func,
    onHandleTooltipMouseOut: PropTypes.func,
    isPostAppraisal: PropTypes.bool,
};

InsuranceRequestWizardStep3LinkTooltip.defaultProps = {
    onHandleTooltipMouseOver: () => { },
    onHandleTooltipMouseOut: () => { },
    isPostAppraisal: false
};

module.exports = InsuranceRequestWizardStep3LinkTooltip;
